import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M15.556 3.653a.966.966 0 1 0-1.366-1.366l-2.629 2.629a.963.963 0 0 0-.282.715.965.965 0 0 0 .282.719l2.63 2.629a.966.966 0 0 0 1.365-1.366l-1.04-1.041 5.913.017a6.34 6.34 0 0 1 6.322 6.322l.024 8.136a.966.966 0 1 0 1.932-.005l-.024-8.137a8.273 8.273 0 0 0-8.249-8.248L14.57 4.64l.986-.987z"></path><path d="M4.94 12.093c-.91 0-1.647.738-1.647 1.648v14.607c0 .91.738 1.648 1.648 1.648h14.607c.91 0 1.648-.738 1.648-1.648V13.741c0-.91-.738-1.648-1.648-1.648H4.941z"></path>';
export var RotateCounterClockwiseSVG = function RotateCounterClockwiseSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
RotateCounterClockwiseSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(RotateCounterClockwiseSVG);